module.exports = __webpack_public_path__ + "img/brunsviger2.29b02855.jpg";